Apt.fn.extend('account-post', {}, {
	/**
	 * Bind actions for the feature step
	 */
	featureSetup() {
		//
	}
});